import bundleApiCall from './bundle';
import cancelApiCall from './cancel';
import cancelBatchApiCall from './cancelBatch';
import cleanupAllApiCall from './cleanupAll';
import continueApiCall from './continue';
import detailApiCall from './detail';
import editApiCall from './edit';
import generateApiCall from './generate';
import listApiCall from './list';
import rebundleApiCall from './rebundle';
import rebundleAllApiCall from './rebundleAll';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  edit: editApiCall,
  delete: editApiCall,
  create: generateApiCall,
  cancel: cancelApiCall,
  cancelBatch: cancelBatchApiCall,
  cleanupAll: cleanupAllApiCall,
  rebundle: rebundleApiCall,
  rebundleAll: rebundleAllApiCall,
  bundle: bundleApiCall,
  continue: continueApiCall,
};

export default ApiCall;
